import { render } from "./Filter.vue?vue&type=template&id=01d2b19a"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\TUASWEB\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__